import ReferralActionType from './referralActionType';

export const getReferral = (referralId) => ({
  type: ReferralActionType.GET_REFERRAL,
  payload: { referralId },
});

export const saveReferral = (data) => ({
  type: ReferralActionType.SAVE_REFERRAL,
  payload: { data },
});

export const resetReferral = () => ({
  type: ReferralActionType.RESET_REFERRAL,
});

export const getReferralCommissionPeriods = (referralId, params) => ({
  type: ReferralActionType.GET_REFERRAL_COMMISSION_PERIODS,
  payload: {
    referralId,
    params,
  },
});

export const getReferralReferees = (batchId, params) => ({
  type: ReferralActionType.GET_REFERRAL_REFEREES,
  payload: { batchId, params },
});

export const saveReferralReferees = (data) => ({
  type: ReferralActionType.SAVE_REFERRAL_REFEREES,
  payload: { data },
});

export const resetReferralReferees = () => ({
  type: ReferralActionType.RESET_REFERRAL_REFEREES,
});

export const getPlayerReferralReferees = (playerId, params) => ({
  type: ReferralActionType.GET_PLAYER_REFERRAL_REFEREES,
  payload: { playerId, params },
});

export const savePlayerReferralReferees = (data) => ({
  type: ReferralActionType.SAVE_PLAYER_REFERRAL_REFEREES,
  payload: { data },
});

export const resetPlayerReferralReferees = () => ({
  type: ReferralActionType.RESET_PLAYER_REFERRAL_REFEREES,
});

export const getPlayerReferrals = (playerId, params) => ({
  type: ReferralActionType.GET_PLAYER_REFERRALS,
  payload: { playerId, params },
});

export const savePlayerReferrals = (data) => ({
  type: ReferralActionType.SAVE_PLAYER_REFERRALS,
  payload: { data },
});

export const resetPlayerReferrals = () => ({
  type: ReferralActionType.RESET_PLAYER_REFERRALS,
});

export const savePlayerReferralPeriods = (data) => ({
  type: ReferralActionType.SAVE_PLAYER_REFERRAL_PERIODS,
  payload: { data },
});

export const resetPlayerReferralPeriods = () => ({
  type: ReferralActionType.RESET_PLAYER_REFERRAL_PERIODS,
});

export const saveReferralAccumulatedPeriods = (data) => ({
  type: ReferralActionType.SAVE_REFERRAL_ACCUMULATED_PERIODS,
  payload: { data },
});

export const saveReferralTransferredPeriods = (data) => ({
  type: ReferralActionType.SAVE_REFERRAL_TRANSFERRED_PERIODS,
  payload: { data },
});

export const saveReferralFailedPeriods = (data) => ({
  type: ReferralActionType.SAVE_REFERRAL_FAILED_PERIODS,
  payload: { data },
});
